import { render, staticRenderFns } from "./DetailViewGroupField.vue?vue&type=template&id=0be7a78e&scoped=true"
import script from "./DetailViewGroupField.vue?vue&type=script&lang=js"
export * from "./DetailViewGroupField.vue?vue&type=script&lang=js"
import style0 from "./DetailViewGroupField.vue?vue&type=style&index=0&id=0be7a78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be7a78e",
  null
  
)

export default component.exports